const PLUTUS_USER_ID_PATTERN = /^[A-Za-z0-9]{32}$/;

export function isValidPlutusUserId(value: unknown): value is string {
  return typeof value === "string" && PLUTUS_USER_ID_PATTERN.test(value);
}
